import useFetch from '@hooks/useFetch';
import { HOST_TYPE } from '@utils/api-helper/host';

const useGoalSpecificCentreLinks = (goalUID) => {
  const key = `api/city-specific-offline-centres/goal-specific-redirection-links/goal/${goalUID}`;
  const {
    data: offlineCititesMapping,
    isValidating,
    ...rest
  } = useFetch(key, { useCamelCase: false, hostType: HOST_TYPE.CMS });
  return { offlineCititesMapping, isValidating, ...rest };
};

export default useGoalSpecificCentreLinks;
